var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorporateFare1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33268 15.5C1.87435 15.5 1.48199 15.3368 1.1556 15.0104C0.82921 14.684 0.666016 14.2917 0.666016 13.8333V2.16667C0.666016 1.70833 0.82921 1.31597 1.1556 0.989583C1.48199 0.663194 1.87435 0.5 2.33268 0.5H7.33268C7.79102 0.5 8.18338 0.663194 8.50977 0.989583C8.83615 1.31597 8.99935 1.70833 8.99935 2.16667V3.83333H15.666C16.1243 3.83333 16.5167 3.99653 16.8431 4.32292C17.1695 4.64931 17.3327 5.04167 17.3327 5.5V13.8333C17.3327 14.2917 17.1695 14.684 16.8431 15.0104C16.5167 15.3368 16.1243 15.5 15.666 15.5H2.33268ZM2.33268 13.8333H7.33268V12.1667H2.33268V13.8333ZM2.33268 10.5H7.33268V8.83333H2.33268V10.5ZM2.33268 7.16667H7.33268V5.5H2.33268V7.16667ZM2.33268 3.83333H7.33268V2.16667H2.33268V3.83333ZM8.99935 13.8333H15.666V5.5H8.99935V13.8333ZM10.666 8.83333V7.16667H13.9993V8.83333H10.666ZM10.666 12.1667V10.5H13.9993V12.1667H10.666Z",
    fill: "#0129FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateFare1);
export default __webpack_public_path__ + "static/media/corporate_fare1.535da20e23ea821ae6ef17c120d23208.svg";
export { ForwardRef as ReactComponent };